/**
 * Recursively converts Map and other non-plain values to plain objects/arrays
 * so that JSON Schema $ref resolution (bracket access) works in dereference-json-schema.
 */
export const toPlainSchemaValue = (val: unknown): unknown => {
    if (val == null) return val;
    if (val instanceof Map) {
        return Object.fromEntries(
            [...val.entries()].map(([k, v]) => [k, toPlainSchemaValue(v)])
        );
    }
    if (Array.isArray(val)) return val.map(toPlainSchemaValue);
    if (typeof val === 'object') {
        return Object.fromEntries(
            Object.entries(val).map(([k, v]) => [k, toPlainSchemaValue(v)])
        );
    }
    return val;
}